import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchOCClaimSettlements } from '../data-provider/claim-settlements';
import type {
  GetOCClaimSettlementsRequestParams,
  OCClaimSettlementsResponse,
} from '../data-provider/claim-settlements/api';
import { getOCClaimInfiniteNextPageParam } from '../data-provider/utils/get-next-page';

export interface UseGetOCClaimSettlementsParams {
  fbOcKey: number | undefined;
  pageSize?: number;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export const useGetOCClaimSettlements = ({
  fbOcKey,
  pageSize = 10,
  sortColumn = 'SettlementSeq',
  sortDirection = 'DESC',
}: UseGetOCClaimSettlementsParams) => {
  return useInfiniteQuery<OCClaimSettlementsResponse>({
    enabled: Boolean(fbOcKey),
    getNextPageParam: getOCClaimInfiniteNextPageParam,
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) => {
      const params: GetOCClaimSettlementsRequestParams = {
        fbOcKey: Number(fbOcKey),
        pageIndex: Number(pageParam),
        pageSize,
        sortColumn,
        sortDirection,
      };
      return fetchOCClaimSettlements(params);
    },
    queryKey: ['claims-over-charge-settlements', fbOcKey, sortColumn, sortDirection],
    select: (data) => {
      const pages = data.pages ?? [];
      const flatSettlements = pages.flatMap((page) => page?.data ?? []);
      const lastPage = pages[pages.length - 1];
      const pageIndex = pages.length;

      return {
        ...data,
        data: flatSettlements,
        flatSettlements,
        pageIndex,
        totalAmount: Number(lastPage?.totalAmount ?? 0),
        totalRows: Number(lastPage?.totalRows ?? 0),
      };
    },
  });
};
